import { useLocation } from "react-router-dom";
import NotificationList from "./NotificationList";

export const NotificationsListPage = () => {
    const location = useLocation();
    return <NotificationList key={location.key} />
 }